export default __webpack_public_path__ + "static/media/unfinished2.ab4c977c.png";